import { render, staticRenderFns } from "./previewFile.vue?vue&type=template&id=7063d3b9&scoped=true"
import script from "./previewFile.vue?vue&type=script&lang=js"
export * from "./previewFile.vue?vue&type=script&lang=js"
import style0 from "./previewFile.vue?vue&type=style&index=0&id=7063d3b9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7063d3b9",
  null
  
)

export default component.exports